"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const query_string_1 = __importDefault(require("query-string"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("@mui/material/styles");
//helpers
const services_1 = require("../../../common/services");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const translations_1 = __importDefault(require("../../../common/translations"));
const themeHelper_1 = require("../../../common/helpers/themeHelper");
const filterHelper_1 = __importDefault(require("../../../common/helpers/filterHelper"));
const helpers_1 = require("../../../common/helpers/helpers");
const localeHelper_1 = require("../../../common/helpers/localeHelper");
// components
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const Overview_1 = __importDefault(require("./Overview"));
const NoMatch_1 = __importDefault(require("../../../common/components/Other/NoMatch"));
const DEFAULT_LOCALE = 'de';
const MainLayoutContainer = styled_components_1.default.div `
  background-color: ${props => props.theme.palette.dsInteractiveBackground};

  &.interactive {
    .call-to-action-detail {
      background-color: ${props => props.theme.palette.dsInteractiveBackground};
      color: black;
    }
  }
`;
const availableSongs = [
    'interalpen-song',
    'robinson-clubsong-de',
    'robinson-clubsong-en',
    'sacher-song',
    'tml-clubsong',
];
const MainLayout = ({ currentLocale, mode, updateStore, userSelectedLocale, rootElement, backofficeSettings, streamData, isBackgroundMusicMuted, }) => {
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    const [languageLoading, setLanguageLoading] = (0, react_1.useState)(false);
    const [theme, setTheme] = (0, react_1.useState)((0, styles_1.createTheme)());
    const location = (0, react_router_dom_1.useLocation)();
    const match = (0, react_router_dom_1.useRouteMatch)();
    const urlSearchParams = query_string_1.default.parse(location.search);
    (0, react_1.useEffect)(() => {
        if (!streamData) {
            initialSetup();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (streamData) {
            initialSetup();
        }
    }, [streamData]);
    (0, react_1.useEffect)(() => {
        if (userSelectedLocale) {
            setLanguageLoading(true);
            initialSetup();
        }
    }, [userSelectedLocale]);
    const calculateStep = (activitiesCount, extraItemsCount) => {
        return activitiesCount <= extraItemsCount
            ? Math.ceil(activitiesCount / extraItemsCount)
            : Math.floor(activitiesCount / extraItemsCount);
    };
    const generateInitialSlides = (activities, extraItems) => {
        if (extraItems.length < 1) {
            return Array.from(activities);
        }
        const extraItemsCount = extraItems.length;
        const activitiesCount = activities.length;
        // we create an array of activities.length + directoriesAndOffers.length elements and fill it with empty values
        const slides = new Array(extraItemsCount + activitiesCount).fill({});
        // we calculate where in the array we need to insert directories/offers based on the number of activities and locales
        const step = calculateStep(activitiesCount, extraItemsCount);
        let insertAt = step;
        let delta = 0;
        // we map through the directories/offers and insert them in the empty array based on the step calculated above
        extraItems.map((item) => {
            slides[insertAt + delta] = item;
            // the next location is updated
            insertAt += step;
            // we also account for the delta
            delta += 1;
            return item;
        });
        let activityListIndex = 0;
        // we map thourgh the slides array and add activities in the empty spots
        slides.map((slide, index) => {
            if (Object.keys(slide).length < 1) {
                if (activities[activityListIndex]) {
                    slides[index] = Object.assign(activities[activityListIndex]);
                    activityListIndex += 1;
                }
            }
            return slide;
        });
        // we filter the empty values if there are any left
        return slides.filter(slide => Object.keys(slide).length > 0);
    };
    const addInterstitialSlides = (carouselSlides, weatherData, backofficeSettings, queryParams) => {
        const isHandoverActiveFromStream = !queryParams.hidehandover;
        const isWeatherActiveFromStream = !queryParams.hideweather;
        const addHandoverSlide = streamData ? isHandoverActiveFromStream : backofficeSettings === null || backofficeSettings === void 0 ? void 0 : backofficeSettings.dsEnableHandoverScreen;
        const addWeatherSlide = (streamData ? isWeatherActiveFromStream : backofficeSettings === null || backofficeSettings === void 0 ? void 0 : backofficeSettings.dsEnableWeatherInterstitial) &&
            Object.keys(weatherData).length > 0;
        if (!addHandoverSlide && !addWeatherSlide) {
            return carouselSlides;
        }
        const handoverSlide = { type: 'handover' };
        const weatherSlide = Object.assign(weatherData, { type: 'weather' });
        const addBothTypes = addHandoverSlide && addWeatherSlide;
        if (addBothTypes) {
            carouselSlides.splice(1, 0, weatherSlide);
            if (carouselSlides.length < 7) {
                return [...carouselSlides, handoverSlide];
            }
            let interstitialSlide = weatherSlide;
            const reducedRes = carouselSlides.reduce((acc, curr, index) => {
                if (index % 6 === 0 && index !== 0) {
                    interstitialSlide = interstitialSlide.type === 'handover' ? weatherSlide : handoverSlide;
                    //@ts-ignore
                    return [...acc, curr, interstitialSlide];
                }
                return [...acc, curr];
            }, []);
            return reducedRes;
        }
        const slideToAdd = addHandoverSlide ? handoverSlide : weatherSlide;
        carouselSlides.splice(1, 0, slideToAdd);
        const reducedRes = carouselSlides.reduce((acc, curr, index) => {
            if (index % 8 === 0 && index !== 0) {
                return [...acc, curr, slideToAdd];
            }
            return [...acc, curr];
        }, []);
        return reducedRes;
    };
    const getInitialLocale = (queryParams, params) => __awaiter(void 0, void 0, void 0, function* () {
        const queryLocale = Array.isArray(queryParams.locale) ? queryParams.locale[0] : queryParams.locale;
        if (queryLocale)
            return queryLocale;
        try {
            const venueData = (yield services_1.apiService.getVenueFeed(Object.assign(Object.assign({}, params), { locale: DEFAULT_LOCALE })));
            return venueData.defaultLocale;
        }
        catch (error) {
            console.error('Error fetching venue data:', error);
            return DEFAULT_LOCALE;
        }
    });
    const generatePromiseList = (queryParams, promiseParams) => {
        const promises = {
            activities: [],
            directory: [],
            offers: [],
            weather: services_1.apiService.getWeather(promiseParams),
        };
        const queryLocales = Array.isArray(queryParams.locale)
            ? queryParams.locale
            : [queryParams.locale ? queryParams.locale : promiseParams.locale];
        const isInteractive = queryParams.mode === 'interactive';
        const locales = isInteractive ? [promiseParams.locale] : queryLocales;
        locales.forEach((locale) => {
            const updatedPromiseParams = Object.assign(Object.assign({}, promiseParams), { locale });
            promises.activities.push(services_1.apiService.getActivitiesFeed(updatedPromiseParams)); // ALL ACTIVITIES
            if (queryParams.convention) {
                promises.activities.push(services_1.apiService.getActivitiesInConvention(queryParams.convention, updatedPromiseParams));
            }
            promises.directory.push(services_1.apiService.getDirectoryFeed(updatedPromiseParams));
            promises.offers.push(services_1.apiService.getOffersFeed(updatedPromiseParams));
        });
        return promises;
    };
    const initialSetup = () => __awaiter(void 0, void 0, void 0, function* () {
        const { params } = match;
        const queryParams = streamData ? streamData : urlSearchParams;
        const initialLocale = yield getInitialLocale(queryParams, params);
        const currentLocale = userSelectedLocale || initialLocale;
        const isMultipleLocales = Array.isArray(queryParams.locale);
        const updatedQueryParams = userSelectedLocale ? Object.assign(Object.assign({}, queryParams), { locale: userSelectedLocale }) : queryParams;
        if (updatedQueryParams.locale) {
            updateStore('urlSpecifiedLocale', updatedQueryParams.locale);
        }
        updateStore('currentLocale', currentLocale);
        updateStore('controls', queryParams.controls);
        updateStore('hideAppDownloads', queryParams.hideAppDownloads);
        updateStore('appStoreBannersDisabled', queryParams.appStoreBannersDisabled);
        updateStore('showToday', queryParams.showToday);
        updateStore('showTomorrow', queryParams.showTomorrow);
        updateStore('showDayAfterTomorrow', queryParams.showDayAfterTomorrow);
        updateStore('showQrCode', queryParams.showQrCode);
        const venue = (yield services_1.apiService.getVenueFeed(Object.assign(Object.assign({}, params), { locale: currentLocale })));
        const navigations = yield services_1.apiService.getNavigationsFeed(currentLocale, venue.slug);
        updateStore('navigations', navigations);
        translations_1.default.defaultLocale = Object.keys(translations_1.default.translations[venue.defaultLocale]).length > 0 ? venue.defaultLocale : 'en';
        // when the translation is missing, set defaultLocale to "en"
        translations_1.default.missingTranslation = () => {
            translations_1.default.defaultLocale = 'en';
        };
        (0, localeHelper_1.setupInternationalization)(currentLocale, venue);
        setupTheming(params);
        if (venue.interests) {
            const bubbleFilters = filterHelper_1.default.getBubbleFilters(venue);
            updateStore('bubbleFilters', bubbleFilters);
        }
        const enabledLocales = (0, localeHelper_1.getEnabledLocales)(venue);
        updateStore('enabledLocales', enabledLocales);
        updateStore('deeplink', venue.deeplink);
        updateStore('venue', venue);
        updateStore('queryParams', queryParams);
        updateStore('timezone', venue.timezone);
        updateStore('backofficeSettings', Object.assign(Object.assign({}, venue.settings), { dsEnableHandoverScreen: venue.dsEnableHandoverScreen, showWeather: venue.showWeather }));
        updateStore('baseUrl', match.url);
        updateStore('urlParams', match.params);
        if (updatedQueryParams.mode) {
            const interactionType = String(updatedQueryParams.mode);
            updateStore('mode', interactionType);
            rootElement.classList.add(interactionType);
        }
        const promiseParams = Object.assign(Object.assign({}, params), { locale: currentLocale, daysToFetch: updatedQueryParams.daysToFetch });
        const promises = generatePromiseList(updatedQueryParams, promiseParams);
        const weatherData = yield promises.weather;
        const activityResponse = [].concat(...(yield Promise.all(promises.activities))); // ALL ACTIVITIES
        const directoryResponse = [].concat(...(yield Promise.all(promises.directory)));
        const offersResponse = [].concat(...(yield Promise.all(promises.offers)));
        const directoriesAndOffersCollection = [...directoryResponse, ...offersResponse];
        const flattenedDirectoriesAndOffers = filterHelper_1.default.flattenTreeStructure(directoriesAndOffersCollection);
        let finalActivities = [];
        let finalDirectoriesAndOffers = [];
        // If data comes from the ds_streams api endpoint instead of the query params
        if (updatedQueryParams.contents) {
            const contents = updatedQueryParams.contents;
            const activityContents = contents.filter(content => content.type === 'activity').map(content => content.id);
            const activities = activityResponse.filter(activity => {
                const idFromDeeplink = `-${activity.deeplink.split('--').pop()}`;
                return activityContents.includes(idFromDeeplink);
            });
            finalActivities = sortCollection(activities);
            const directoryContents = contents.filter(content => content.type !== 'activity');
            finalDirectoriesAndOffers = sortCollection(flattenedDirectoriesAndOffers.filter(dirItem => directoryContents.some(content => content.type === dirItem.type && content.id === dirItem.id)));
        }
        else {
            const filteredActivities = helpers_1.Helpers.compose(filterHelper_1.default.filterActivitiesByBackofficeTags, filterHelper_1.default.filterCollectionByQueryParams)(activityResponse, updatedQueryParams, venue);
            finalActivities = sortCollection(isMultipleLocales ? handleMultipleLanguages(filteredActivities) : filteredActivities);
            const filteredDirectoriesAndOffersToShow = filterHelper_1.default.filterCollectionByQueryParams(flattenedDirectoriesAndOffers, updatedQueryParams, venue);
            const sortedDirectoriesAndOffers = sortCollection(filterHelper_1.default.filterOffersAndDirectoriesByBackofficeTags(filteredDirectoriesAndOffersToShow, updatedQueryParams));
            finalDirectoriesAndOffers = isMultipleLocales
                ? handleMultipleLanguages(sortedDirectoriesAndOffers)
                : sortedDirectoriesAndOffers;
        }
        const itemsWithIncreasedFrequency = [...finalActivities, ...finalDirectoriesAndOffers].filter((item) => item.dsFrequency !== 'standard');
        const initialSlides = generateInitialSlides(finalActivities, [
            ...itemsWithIncreasedFrequency,
            ...finalDirectoriesAndOffers,
        ]);
        const finalSlides = addInterstitialSlides(initialSlides, weatherData, backofficeSettings, updatedQueryParams);
        updateStore('finalActivities', finalActivities);
        updateStore('slides', finalSlides);
        updateStore('weather', weatherData);
        updateStore('directory', filterHelper_1.default.filterHiddenContentInTreeStructure(directoryResponse));
        updateStore('offers', filterHelper_1.default.filterHiddenContentInTreeStructure(offersResponse));
        setLoaded(true);
        setLanguageLoading(false);
    });
    const setupTheming = (params) => __awaiter(void 0, void 0, void 0, function* () {
        const brandSettings = (yield services_1.apiService.getBrandFeed(params.brand));
        const enhancedAppTheme = (0, themeHelper_1.getAppTheme)(params, brandSettings.brand.theme);
        updateStore('brandInfo', brandSettings);
        updateStore('brandSettings', enhancedAppTheme);
        // We create a style tag in the head in which we add the theme font face
        // We do this because injecting the font face globally using styled components results in flickering on rerenders
        // https://github.com/styled-components/styled-components/issues/1593
        if (document && enhancedAppTheme.fontFamily) {
            const head = document.getElementsByTagName('head')[0];
            const style = document.createElement('style');
            style.innerHTML = enhancedAppTheme.fontFamily;
            head.appendChild(style);
        }
        setTheme((0, styles_1.createTheme)({
            palette: {
                // we set the mainAppColor as the primary color from backoffice
                // and the primary color as the secondary color from backoffice
                // we do it this way because the material library wants to set the primary color as a default for many small components and those components should be colored in the secondary color
                // main color theme of the app,
                mainAppColor: {
                    main: enhancedAppTheme.colorPrimary,
                    contrastText: enhancedAppTheme.colorOnPrimary,
                    light: enhancedAppTheme.colorPrimaryLighter,
                    dark: enhancedAppTheme.colorPrimaryDarker,
                },
                // used for buttons, inputs, CTA's styling, other various places where we need this accent
                primary: {
                    main: enhancedAppTheme.colorSecondary,
                    contrastText: enhancedAppTheme.colorOnSecondary,
                },
                // not used currently
                secondary: {
                    main: enhancedAppTheme.colorSecondary,
                    contrastText: enhancedAppTheme.colorOnSecondary,
                },
                colorAppBar: {
                    main: enhancedAppTheme.colorAppBar,
                    contrastText: enhancedAppTheme.colorOnAppBar,
                },
                colorOnAppBar: {
                    main: enhancedAppTheme.colorOnAppBar,
                    contrastText: enhancedAppTheme.colorOnAppBar,
                },
                colorTiles: enhancedAppTheme.colorTiles,
                dsInteractiveBackground: params.brand === 'upstalsboom-wyk-auf-foehr' ? '#EBEBEB' : '#f5f5f5',
                contrastThreshold: 3,
                tonalOffset: 0.2,
            },
            // MUI typography elements overwrite the font we set in the <head>, so we disable this behaviour by giving it an empty string
            typography: {
                fontFamily: '',
            },
            logo: enhancedAppTheme.logo,
        }));
    });
    const sortCollection = (collection) => {
        const sortedCollection = [];
        const unsortedCollection = collection;
        const checkedIds = [];
        unsortedCollection.map(item => {
            if (checkedIds.includes(item.id)) {
                return item;
            }
            const similarItems = collection.filter(sameItem => item.id === sameItem.id);
            sortedCollection.push(...similarItems);
            checkedIds.push(item.id);
            return item;
        });
        return sortedCollection;
    };
    const handleMultipleLanguages = (collection) => collection
        .map((item) => {
        const similarItemsWithDifferentLanguage = collection.filter((similarItem) => item.contentId === similarItem.contentId && item.locale !== similarItem.locale);
        return Object.assign(item, { switchLanguages: [item, ...similarItemsWithDifferentLanguage] });
    })
        .filter((item) => { var _a; return ((_a = item.locale) === null || _a === void 0 ? void 0 : _a.substr(0, 2)) === currentLocale; });
    if (!loaded) {
        return (react_1.default.createElement("div", { className: "overlay" },
            react_1.default.createElement(Loader_1.default, null)));
    }
    const isLinear = mode === 'linear';
    const isDailyView = mode === 'daily_view';
    const isInteractive = mode === 'interactive';
    const backgroundSong = availableSongs.indexOf(urlSearchParams.song) > -1 ? urlSearchParams.song : '';
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(MainLayoutContainer, { className: `main-content
              ${isLinear ? 'linear' : ''} ${isDailyView ? 'no-top-padding' : ''} ${isInteractive ? 'interactive' : ''}` },
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: `${match.url}/overview`, component: Overview_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: `${match.url}/404`, component: NoMatch_1.default })),
            languageLoading && (react_1.default.createElement(material_1.Backdrop, { open: languageLoading, sx: { color: '#fff', zIndex: 9999 } },
                react_1.default.createElement(material_1.CircularProgress, { size: 60, color: "primary" }))),
            backgroundSong && (react_1.default.createElement("audio", { muted: isBackgroundMusicMuted, loop: true, autoPlay: true },
                react_1.default.createElement("source", { src: `/songs/${backgroundSong}.mp3`, type: "audio/mp3" }))))));
};
const mapStoreToProps = store => {
    const storeLocale = store.getValue('userSelectedLocale');
    const persistedLocale = localStorage.getItem('language');
    const mode = store.getValue('mode');
    const userSelectedLocale = mode
        ? mode === 'interactive'
            ? persistedLocale || storeLocale || ''
            : storeLocale || ''
        : '';
    return {
        userSelectedLocale,
        rootElement: store.getValue('rootElement'),
        mode,
        backofficeSettings: store.getValue('backofficeSettings'),
        currentLocale: store.getValue('currentLocale'),
        isBackgroundMusicMuted: store.getValue('isBackgroundMusicMuted'),
    };
};
exports.default = (0, withStore_1.default)(mapStoreToProps)(MainLayout);
